import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
const useHistory = () => {
  const navigate = useNavigate();
  return useMemo(
    () => ({
      goBack: () => navigate(-1),
      push: (to) => navigate(to),
      pushWithState: (to, state) => navigate(to, { state }),
      replace: (to) => navigate(to, { replace: true })
    }),
    [navigate]
  );
};
export default useHistory;
